export function scoreFor(t) {
    // Explicit score wins when set — always snapped to a multiple of 5.
    if (t.score != null) {
        return Math.max(0, Math.min(100, Math.round(Number(t.score) / 5) * 5));
    }
    if (t.impact == null || t.urgency == null)
        return null;
    const raw = Number(t.impact) * Number(t.urgency);
    return Math.max(0, Math.min(100, Math.round(raw / 5) * 5));
}
export function normScore(raw) {
    return Math.min(999, Math.max(0, Math.round(raw)));
}
export function parseInlineTask(raw) {
    let title = raw;
    let est;
    let tag;
    let due;
    let urgDays;
    let group;
    const estM = title.match(/(?:^|\s)(\d+(?:[.,]\d+)?\s*(?:h|m|min))(?:\s|$)/i);
    if (estM) {
        est = estM[1].replace(',', '.').replace(/\s+/g, '');
        title = title.replace(estM[0], ' ').trim();
    }
    const tagM = title.match(/(?:^|\s)#([\w-]+)/);
    if (tagM) {
        tag = tagM[1];
        title = title.replace(tagM[0], ' ').trim();
    }
    // Explicit deadline ONLY when user types keyword. Never auto-assign.
    const dueM = title.match(/(?:^|\s)(heute|morgen|uebermorgen|übermorgen|\+\d+[Tt])(?:\s|$)/i);
    if (dueM) {
        const d = dueM[1].toLowerCase();
        if (d === 'heute') {
            due = 'heute';
            urgDays = 1;
        }
        else if (d === 'morgen') {
            due = '+1T';
            urgDays = 2;
        }
        else if (d === 'übermorgen' || d === 'uebermorgen') {
            due = '+2T';
            urgDays = 3;
        }
        else {
            due = d;
            urgDays = parseInt(d.slice(1), 10);
        }
        group =
            urgDays === 1 ? 'today' :
                urgDays <= 3 ? 'high' :
                    urgDays <= 7 ? 'medium' : 'low';
        title = title.replace(dueM[0], ' ').trim();
    }
    title = title.replace(/\s+/g, ' ').trim();
    return { title, est, tag, due, urgDays, group };
}
